<template lang="pug">
  .conference-form-save
    v-list-item-title.mb-1 Завершите создание
    v-list-item-subtitle.mb-5 Укажите даты проведения и наименование
    api-form(
      v-model="formValues"
      :fields="fields"
      :method="createJazz"
      :inital="formInitialValues"
      :btn-props="{ rounded: true, btnText: 'Создать видеоконференцию', color: 'success' }"
      :success-callback="() => $emit('on-success')"
    )
</template>

<script>
import DurationInput from '@/components/InputFields/DurationInput.vue';

export default {
  props: {
    date: { type: String, default: null },
    groups: { type: Array, default: () => ([]) },
    lesson: { type: Object, default: null },
  },
  data() {
    return {
      formValues: {
        stream_name: '',
        set_password: false,
        date: this.date,
      },
      formInitialValues: {
        date_start: null,
        stream_name: '',
      },
    };
  },
  computed: {
    fields() {
      return [
        {
          text: 'Наименование конференции',
          value: 'title',
          component: 'v-text-field',
          rules: 'required',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Дата проведения',
          value: 'date',
          component: 'sdo-datetime-field',
          rules: 'required',
          component_attrs: {
            'only-date': true,
          },
        },
        {
          text: 'Продолжительность конференции',
          value: 'duration',
          rules: 'required',
          component: DurationInput,
        },
        {
          text: 'Установить пароль',
          value: 'set_password',
          component: 'v-checkbox',
        },
        ...this.formValues.set_password ? [{
          text: 'Пароль',
          value: 'zoom_password',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        }] : [],
      ];
    },
  },
  watch: {
    lesson: {
      handler(val) {
        if (val) {
          this.formValues.title = this.lesson.name;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async createJazz({ data, obs }) {
      const datetimeStart = `${data.date} ${data.duration.start}`;
      const { duration } = data.duration;
      const preparedData = {
        date_start: datetimeStart,
        lesson_id: this.lesson?.id,
        duration,
        meeting: {
          name: data.title,
          topic: data.title,
          duration,
          password: data.zoom_password,
          start_time: datetimeStart,
          meeting_type: 1,
          type: 1,
          settings: {
            participant_video: false,
            watermark: false,
            host_video: false,
          },
        },
        groups: this.groups.map((i) => i.id),
      };
      return this.$api.schedule.create(preparedData, obs);
    },
  },
};
</script>
